import { Component, OnInit } from '@angular/core';
import { EolDataStoreService } from './services/eol-data-store.service';

@Component({
  selector: 'app-eol',
  templateUrl: './eol.component.html',
  styleUrls: ['./eol.component.scss']
})
export class EolComponent implements OnInit {

  constructor(private eolDataStoreService: EolDataStoreService) {}

  ngOnInit() {
    this.eolDataStoreService.loadFieldworkData();
  }

}
